module.exports = __webpack_public_path__ + "img/send_w.1bccaaa9.svg";